import makeQueryString from './makeQueryString';

const addParamsToHash = (url, params = {}) => {
  const queryString = makeQueryString(params);
  return `${url}#${queryString}`;
};

export default addParamsToHash;
